module.exports = __webpack_public_path__ + "static/media/Step 3-Treasure_Cards.b5d3514f.png";